import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const STORAGE_KEY = "glamcanva_cookie_consent_v1";

export default function CookieConsent() {
  const { language } = useLanguage();
  const isEs = language === "es";
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) setVisible(true);
    } catch {
      // ignore (SSR / restricted storage)
    }
  }, []);

  const decide = (value: "accepted" | "rejected") => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={isEs ? "Aviso de cookies" : "Cookies notice"}
      className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 sm:bottom-4 sm:max-w-md z-50 glass rounded-2xl border border-primary/20 shadow-lg p-4 animate-in fade-in slide-in-from-bottom-4"
    >
      <button
        onClick={() => decide("rejected")}
        aria-label={isEs ? "Cerrar" : "Close"}
        className="absolute top-2 right-2 text-foreground/60 hover:text-foreground"
      >
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-3 mb-3">
        <Cookie className="w-5 h-5 text-primary mt-0.5 shrink-0" />
        <p className="text-sm text-foreground/80 leading-relaxed pr-6">
          {isEs
            ? "Usamos cookies propias y de terceros (Google AdSense, analítica) para mejorar tu experiencia y mostrar publicidad relevante."
            : "We use first and third-party cookies (Google AdSense, analytics) to improve your experience and show relevant ads."}
          {" "}
          <Link to="/cookies" className="text-primary underline hover:no-underline">
            {isEs ? "Más información" : "Learn more"}
          </Link>
          .
        </p>
      </div>
      <div className="flex flex-wrap gap-2 justify-end">
        <Button size="sm" variant="ghost" onClick={() => decide("rejected")}>
          {isEs ? "Rechazar" : "Reject"}
        </Button>
        <Button size="sm" onClick={() => decide("accepted")}>
          {isEs ? "Aceptar" : "Accept"}
        </Button>
      </div>
    </div>
  );
}
